import './index.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { ConfigureStore } from './stores/ConfigureStore';
import { Provider } from 'react-redux';
import { StoreInitializer } from './stores/StoreInitializer';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const rootElement = document.getElementById('root');
export const store = ConfigureStore({});
const storeInitializer = new StoreInitializer(store);
storeInitializer.InitializeStore();

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </Provider>,
    rootElement);

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx